// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7b4414d7","732":"2ee39abb","977":"d8ffc1d6"}[chunkId] + ".chunk.js";
};